import { Reveal } from "../components/Reveal";
import Calculator from "../components/Calculator";

export default function CalculatorSection() {
  return (
    <section id="calculator" className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
      <Reveal className="max-w-3xl mb-14">
        <h2 className="font-display text-4xl md:text-6xl tracking-tighter font-medium leading-[0.98]">
          See what your time is really worth.
        </h2>
        <p className="mt-6 text-lg md:text-xl text-neutral-500 leading-relaxed">
          Drag the sliders to match your week. Watch how many hours and dollars your right hand hands back to you.
        </p>
      </Reveal>
      <Reveal delay={0.1}><Calculator /></Reveal>
    </section>
  );
}
